module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu-button",
    on: {
      "click": function($event) {
        _vm.isOpen = true
      }
    }
  }, [_c('div', {
    staticClass: "fa fa-sliders"
  })]), _vm._v(" "), _c('div', {
    staticClass: "left-menu",
    class: {
      visible: _vm.isOpen
    },
    attrs: {
      "id": "menu"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.close($event)
      }
    }
  }, [_c('ul', {
    staticClass: "menu-main"
  }, [_c('li', {
    staticClass: "title",
    on: {
      "click": _vm.close
    }
  }, [_vm._m(0), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "menu title"
    }
  }, [_vm._v("Meteo Parapente")])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'favorites')
      }
    }
  }, [(_vm.isMenuOpen('favorites')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-star fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "menu title"
    }
  }, [_vm._v("Favorites")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('favorites')) ? _c('div', [_vm._l((_vm.$store.state.favorites.list), function(favorite, index) {
    return _c('div', [(!_vm.isMenuOpen('favorites/' + index)) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.loadFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: favorite.uid === _vm.$store.state.favorites.home ? 'fa-home' : ''
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "padding": "0 5px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openMenu($event, 'favorites/' + index)
        }
      }
    }, [_vm._m(1, true)]), _vm._v("\n            " + _vm._s(favorite.name) + "\n          ")]) : _c('li', {
      on: {
        "click": function($event) {
          _vm.openMenu($event, 'favorites')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('strong', [_vm._v(_vm._s(favorite.name))])]), _vm._v(" "), (_vm.isMenuOpen('favorites/' + index)) ? _c('div', [_c('li', {
      on: {
        "click": function($event) {
          _vm.loadFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-external-link"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Open")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.renameFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-pencil"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Rename")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.moveToUpFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-level-up"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Move to top")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.setHomeFavorite(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-home"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Set as homepage")])], 1), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.deleteFavorite(index, favorite.name)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw"
    }), _c('i', {
      staticClass: "fa fa-fw fa-trash"
    }), _vm._v(" "), _c('translate', {
      attrs: {
        "translate-context": "favorites menu"
      }
    }, [_vm._v("Delete")])], 1)]) : _vm._e()])
  }), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.addFavorite
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus-circle"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "favorites menu"
    }
  }, [_vm._v("Add new…")])], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.contributor) ? _c('li', {
    staticClass: "contribute spacer",
    on: {
      "click": _vm.openContribution
    }
  }, [_c('i', {
    staticClass: "fa fa-heart fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "contribute menu"
    }
  }, [_vm._v("Become a member")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'windy')
      }
    }
  }, [(_vm.isMenuOpen('windy')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-caret-right fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('windy')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('windalti')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw star"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")]), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('windsfc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Ground")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('windblavg')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Boundary layer")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('windbltop')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Ceiling of b. layer")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('blwindshear')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Wind Shear")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("B. Layer")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('slp')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Pressure")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu wind"
    }
  }, [_vm._v("Sea level")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'rising')
      }
    }
  }, [(_vm.isMenuOpen('rising')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-caret-right fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Updrafts")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('rising')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('wstar')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Thermals")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Velocity")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('bsratio')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Thermals")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Shearing")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('pblh')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Boundary Layer")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Thickness")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('pbltop')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Boundary Layer")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Ceiling")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('wblmaxmin')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("Vertical motion")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu updrafts"
    }
  }, [_vm._v("B. layer")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'foggy')
      }
    }
  }, [(_vm.isMenuOpen('foggy')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-caret-right fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Humidity")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('foggy')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('raintot')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Rain")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("1h")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfracalti')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfract')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("All")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfrach')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("High")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfracm')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Medium")])], 1)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('cfracl')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Clouds")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu humidity"
    }
  }, [_vm._v("Low")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'shiny')
      }
    }
  }, [(_vm.isMenuOpen('shiny')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-caret-right fa-fw"
  }), _vm._v(" "), _c('strong', [_c('translate', {
    attrs: {
      "translate-context": "map menu temperature"
    }
  }, [_vm._v("Temperature")])], 1)]), _vm._v(" "), (_vm.isMenuOpen('shiny')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('tempalti')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu temperature"
    }
  }, [_vm._v("Temperature")]), _vm._v(" "), _vm._m(5)], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setLayer('tc2')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "map menu temperature"
    }
  }, [_vm._v("Temperature")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "map menu temperature"
    }
  }, [_vm._v("Ground")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "tour spacer",
    on: {
      "click": _vm.openTour
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "contribute menu"
    }
  }, [_vm._v("Meetings")])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleInterpolation
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.interpolate, 'fa-toggle-off': !_vm.interpolate
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("Interpolation")])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleXcplanner
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.xcplanner, 'fa-toggle-off': !_vm.xcplanner
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("XC Planner")]), _vm._v(" "), _c('small', [_c('sup', [_c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("experimental")])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleAirspace
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.airspace, 'fa-toggle-off': !_vm.airspace
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("Airspace")])], 1), _vm._v(" "), (_vm.fullscreen !== null) ? _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-compress': _vm.fullscreen, 'fa-expand': !_vm.fullscreen
    }
  }), _vm._v(" "), (!_vm.fullscreen) ? _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("Fullscreen")]) : _c('translate', {
    attrs: {
      "translate-context": "toggle menu"
    }
  }, [_vm._v("Exit Fullscreen")])], 1) : _vm._e(), _vm._v(" "), (!_vm.contributor) ? _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.openLogin
    }
  }, [_c('i', {
    staticClass: "fa fa-user fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "login menu"
    }
  }, [_vm._v("Login")])], 1) : _vm._e(), _vm._v(" "), (_vm.isMenuOpen('news')) ? _c('div', _vm._l((_vm.news), function(article, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.openNews(article)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: article.unread ? 'fa-angle-right' : '',
      staticStyle: {
        "color": "red",
        "font-weight": "bold"
      }
    }), _vm._v("\n          " + _vm._s(article.title) + "\n         ")])
  })) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.openHelp
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "menu"
    }
  }, [_vm._v("Help / Contact / About")])], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'settings')
      }
    }
  }, [(_vm.isMenuOpen('settings')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-wrench fa-fw"
  }), _vm._v(" "), _c('translate', {
    style: ({
      'font-weight': (_vm.isMenuOpen('settings') ? 'bold' : 'normal')
    }),
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Settings")])], 1), _vm._v(" "), (_vm.isMenuOpen('settings')) ? _c('div', [_c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'settings/language')
      }
    }
  }, [(_vm.isMenuOpen('settings/language')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-fw fa-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "flag-icon flag-icon-right",
    class: ("flag-icon-" + (_vm.$language.current))
  }), _vm._v(" "), _c('translate', {
    style: ({
      'font-weight': (_vm.isMenuOpen('settings/language') ? 'bold' : 'normal')
    }),
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Language")])], 1), _vm._v(" "), (_vm.isMenuOpen('settings/language')) ? _c('div', [_c('li', {
    on: {
      "click": _vm.openTranslatePage
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Help us translate!")])], 1), _vm._v(" "), _vm._l((_vm.$language.available), function(language, key) {
    return _c('li', {
      class: {
        active: _vm.$language.current === key
      },
      on: {
        "click": function($event) {
          _vm.changeLanguage(key)
        }
      }
    }, [_c('span', {
      staticClass: "flag-icon",
      class: ("flag-icon-" + key)
    }), _vm._v("\n            " + _vm._s(language) + "\n          ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'settings/timezone')
      }
    }
  }, [(_vm.isMenuOpen('settings/timezone')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-fw fa-clock-o"
  }), _vm._v(" "), _c('translate', {
    style: ({
      'font-weight': (_vm.isMenuOpen('settings/timezone') ? 'bold' : 'normal')
    }),
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Timezone")])], 1), _vm._v(" "), (_vm.isMenuOpen('settings/timezone')) ? _c('div', [_c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleTimezoneOveride
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': !_vm.timezoneOveride, 'fa-toggle-off': _vm.timezoneOveride
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "timezone menu"
    }
  }, [_vm._v("Same as device")])], 1), _vm._v(" "), _vm._l((_vm.timezones), function(zone) {
    return _c('li', {
      class: {
        active: zone.utc.includes(_vm.currentTimezone)
      },
      on: {
        "click": function($event) {
          _vm.setTimezone(zone.utc[0], true)
        }
      }
    }, [(zone.utc.includes(_vm.currentTimezone)) ? _c('i', {
      staticClass: "fa fa-check-square-o"
    }) : _vm._e(), _vm._v(" "), _c('small', [_c('strong', [_vm._v(_vm._s(zone.text.replace(/\((.+)\)\s.+/, '($1)')))])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(zone.text.replace(/\((.+)\)\s/, '')))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'settings/wind-unit')
      }
    }
  }, [(_vm.isMenuOpen('settings/wind-unit')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-tachometer fa-fw"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.$convert.currentLabel))]), _vm._v(" "), _c('translate', [_vm._v("Wind unit")])], 1), _vm._v(" "), (_vm.isMenuOpen('settings/wind-unit')) ? _c('div', [_c('li', {
    on: {
      "click": function($event) {
        _vm.setWindUnit('kmh')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', [_vm._v("km/h")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setWindUnit('knots')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', [_vm._v("knots")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setWindUnit('ms')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', [_vm._v("m/s")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.setWindUnit('mph')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw"
  }), _vm._v(" "), _c('translate', [_vm._v("mph")])], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleExperimental
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.experimental, 'fa-toggle-off': !_vm.experimental
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Experimental features")])], 1), _vm._v(" "), (_vm.experimental) ? _c('div', {
    attrs: {
      "id": "menu-experimental"
    }
  }, [_c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.toggleColorblind
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-toggle-on': _vm.colorblind, 'fa-toggle-off': !_vm.colorblind
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Color blind")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("experimental")])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.resetStore
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Reset all settings")]), _vm._v(" "), _c('small', [_c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("debug")])], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contributor) ? _c('li', {
    staticClass: "spacer email",
    on: {
      "click": function($event) {
        _vm.toggleSubMenu($event, 'contributor')
      }
    }
  }, [(_vm.isMenuOpen('contributor')) ? _c('i', {
    staticClass: "fa fa-caret-down fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-user fa-fw"
  }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.email))])]) : _vm._e(), _vm._v(" "), (_vm.isMenuOpen('contributor')) ? _c('div', [_c('li', {
    staticClass: "spacer email"
  }, [_c('i', {
    staticClass: "fa fa-check fa-fw"
  }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("moment")(_vm.expiration, 'll')))])]), _vm._v(" "), _c('li', {
    staticClass: "spacer",
    on: {
      "click": _vm.changePassword
    }
  }, [_c('i', {
    staticClass: "fa fa-key fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Change password")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-fw"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "settings menu"
    }
  }, [_vm._v("Logout")])], 1)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-close fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-fw fa-pencil-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "padding": "0 5px"
    }
  }, [_c('small', [_c('i', {
    staticClass: "fa fa-fw fa-caret-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrows-v fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrows-v fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('i', {
    staticClass: "fa fa-arrows-v fa-fw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b85a256"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/left-menu.vue
// module id = 337
// module chunks = 1